/**
 * Games balance API
 */
import { getAuthHeaders } from './auth-headers';

export interface GamesBalance {
  paidGames: number;
  freeGamesLeft: number;
  totalFreeGames: number;
  canPlay: boolean;
  platform: 'telegram' | 'vk' | 'guest';
}

export async function fetchGamesBalance(): Promise<GamesBalance | null> {
  try {
    const res = await fetch('/api/games/balance', {
      headers: getAuthHeaders(),
    });
    if (!res.ok) return null;
    return (await res.json()) as GamesBalance;
  } catch {
    return null;
  }
}
